var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',[_c('p',{staticClass:"text-center mt-12 greeting"},[_vm._v(" Tere, "+_vm._s(_vm.$store.getters.user.username)+"! ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }